"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHistoryStore = exports.useGlobalState = exports.useGlobalContext = exports.GlobalProvider = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
class HistoryStore {
    historyList;
    constructor() {
        this.historyList = [];
    }
    getRecentPageHistory(pageName) {
        const matchPageNameHistoryList = this.historyList.filter(history => history.pageName === pageName);
        if (matchPageNameHistoryList.length > 0) {
            return matchPageNameHistoryList[matchPageNameHistoryList.length - 1];
        }
        return null;
    }
    pushHistory(historyItem) {
        this.historyList.push(historyItem);
    }
    clearHistoryForPage(pageName) {
        this.historyList = this.historyList.filter(history => history.pageName !== pageName);
    }
}
const CombinedContext = (0, react_1.createContext)(null);
const GlobalProvider = ({ children }) => {
    const location = (0, react_router_dom_1.useLocation)();
    const [historyStore] = (0, react_1.useState)(() => new HistoryStore());
    const [globalState, setGlobalState] = (0, react_1.useState)({
        isMobile: window.innerWidth <= 767,
        isTablet: window.innerWidth > 767 && window.innerWidth < 1400,
        isDesktop: window.innerWidth >= 1400,
        classesId: '',
    });
    const updateGlobalState = () => {
        setGlobalState(prevState => ({
            ...prevState,
            isMobile: window.innerWidth <= 767,
            isTablet: window.innerWidth > 767 && window.innerWidth < 1400,
            isDesktop: window.innerWidth >= 1400,
        }));
    };
    (0, react_1.useEffect)(() => {
        window.addEventListener('resize', updateGlobalState);
        return () => window.removeEventListener('resize', updateGlobalState);
    }, []);
    const updateClassesId = () => {
        const uuidMatch = location.pathname.match(/\/class\/([0-9a-f-]+)$/i);
        const roomUuid = uuidMatch ? uuidMatch[1] : null;
        setGlobalState(prevState => ({
            ...prevState,
            classesId: roomUuid || '',
        }));
    };
    (0, react_1.useEffect)(() => {
        updateClassesId();
    }, [location]);
    const contextValue = {
        globalState,
        updateGlobalState,
        historyStore,
    };
    return react_1.default.createElement(CombinedContext.Provider, { value: contextValue }, children);
};
exports.GlobalProvider = GlobalProvider;
const useGlobalContext = () => {
    const context = (0, react_1.useContext)(CombinedContext);
    if (!context) {
        throw new Error('useGlobalContext must be used within a GlobalProvider');
    }
    return context;
};
exports.useGlobalContext = useGlobalContext;
const useGlobalState = () => {
    const { globalState } = (0, exports.useGlobalContext)();
    return globalState;
};
exports.useGlobalState = useGlobalState;
const useHistoryStore = () => {
    const { historyStore } = (0, exports.useGlobalContext)();
    return historyStore;
};
exports.useHistoryStore = useHistoryStore;
